export enum USECASE {
    UNDEFINED,
    VACCINATION,
    GENERIC,
    COVID_TEST,
    ACCREDITATION
}
